import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {LoadGatewayPendingConfigCB} from "../../ope/gateway-pending-config/LoadGatewayPendingConfigCB";
import {SaveGatewayPendingConfigCB} from "../../ope/gateway-pending-config/SaveGatewayPendingConfigCB";
import {ConfirmGatewayPendingConfigCB} from "../../ope/gateway-pending-config/ConfirmGatewayPendingConfigCB";
import {
  RevertGatewayFieldsPendingConfigCB
} from "../../ope/gateway-pending-config/RevertGatewayFieldsPendingConfigCB";
import {GetDevicePendingConfigCB} from "../../ope/gateway-pending-config/GetDevicePendingConfigCB";
import {SaveDevicePendingConfigCB} from "../../ope/gateway-pending-config/SaveDevicePendingConfigCB";
import {ReadGatewayPendingConfigFallbackCB} from "../../ope/gateway-pending-config/ReadGatewayPendingConfigFallbackCB";
import {CancelDevicePendingConfigCB} from "../../ope/gateway-pending-config/CancelDevicePendingConfigCB";
import {CancelAllDevicePendingConfigCB} from "../../ope/gateway-pending-config/CancelAllDevicePendingConfigCB";
import {DuplicateDevicePendingConfigCB} from "../../ope/gateway-pending-config/DuplicateDevicePendingConfigCB";
import {RevertDevicePendingConfigCB} from "../../ope/gateway-pending-config/RevertDevicePendingConfigCB";
import {GetGatewayPayloadCB} from "../../ope/gateway-pending-config/GetGatewayPayloadCB";
import {GetGatewaysPayloadCB} from "../../ope/gateway-pending-config/GetGatewaysPayloadCB";

@Injectable({
  providedIn: 'root'
})
export class GatewayPendingConfigOpeService extends BaseOPEService {

  // NOTE: backend maps loadGatewayPendingConfig with @GetMapping while every
  // other ope (including its 3 siblings here) is @PostMapping. execOPE always
  // issues a POST, so this call will 405 until the backend mapping is aligned.
  public loadGatewayPendingConfig(cb: LoadGatewayPendingConfigCB): Promise<any> {
    return this.execOPE(cb);
  }

  public saveGatewayPendingConfig(cb: SaveGatewayPendingConfigCB): Promise<any> {
    return this.execOPE(cb);
  }

  public confirmGatewayPendingConfig(cb: ConfirmGatewayPendingConfigCB): Promise<any> {
    return this.execOPE(cb);
  }

  public revertGatewayFieldsPendingConfig(cb: RevertGatewayFieldsPendingConfigCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getDevicePendingConfig(cb: GetDevicePendingConfigCB): Promise<any> {
    return this.execOPE(cb);
  }

  public saveDevicePendingConfig(cb: SaveDevicePendingConfigCB): Promise<any> {
    return this.execOPE(cb);
  }

  public readGatewayPendingConfigFallback(cb: ReadGatewayPendingConfigFallbackCB): Promise<any> {
    return this.execOPE(cb);
  }

  public cancelDevicePendingConfig(cb: CancelDevicePendingConfigCB): Promise<any> {
    return this.execOPE(cb);
  }

  public cancelAllDevicePendingConfig(cb: CancelAllDevicePendingConfigCB): Promise<any> {
    return this.execOPE(cb);
  }

  public duplicateDevicePendingConfig(cb: DuplicateDevicePendingConfigCB): Promise<any> {
    return this.execOPE(cb);
  }

  public revertDevicePendingConfig(cb: RevertDevicePendingConfigCB): Promise<any> {
    return this.execOPE(cb);
  }

  // Draft-aware counterparts of getGateway/getGateways (KETON-166).
  public getGatewayPayload(cb: GetGatewayPayloadCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getGatewaysPayload(cb: GetGatewaysPayloadCB): Promise<any> {
    return this.execOPE(cb);
  }
}
